import uniq from 'lodash/uniq';
import { createAction } from 'redux-actions';
import Resources from '../../../../helpers/resources';
import { ALL_GROUPS, CLASS_LIST } from '../../filter-constants';
import dropdownDataActions from '../../redux/dropdown-data/dropdown-data-actions';
import dropdownDataSelectors from '../../redux/dropdown-data/dropdown-data-selectors';

export const STUDENTS_BY_GROUP_RETRIEVED = 'STUDENTS_BY_GROUP_RETRIEVED';
export const RESET_STUDENTS_BY_GROUP = 'RESET_STUDENTS_BY_GROUP';

function getStudentsByGroup(classId) {
    return (dispatch, getState) => {
        const currentClassId = dropdownDataSelectors.selectSelectedOptionByType(
            CLASS_LIST
        )(getState()).value;
        if (classId !== currentClassId) {
            return Resources.studentsByGroup
                .get({ classId })
                .send()
                .then((payload) => {
                    const studentsByGroup = mapGroupData(payload.data);
                    dispatch({
                        type: STUDENTS_BY_GROUP_RETRIEVED,
                        payload: studentsByGroup
                    });
                    dispatch(
                        dropdownDataActions.setGroupAndStudentLists(
                            studentsByGroup.groups
                        )
                    );
                });
        }
        return null;
    };
}

const resetStudentsByGroup = createAction(RESET_STUDENTS_BY_GROUP);

function mapGroupData(data) {
    let allStudents = [];
    const groups = data.groups.map((group) => {
        const mappedGroup = { ...group };
        mappedGroup.students = mappedGroup.students.map((student) => ({
            value: student.userProfileId,
            label: `${student.firstName} ${student.lastName}`,
            userId: student.userId
        }));
        allStudents = [
            ...allStudents,
            ...mappedGroup.students.filter(
                (student) => !allStudents.find((s) => s.value === student.value)
            )
        ];
        return mappedGroup;
    });

    // add 'All groups' option which contains all students if more than one group
    allStudents = uniq(allStudents);
    if (groups.length > 1) {
        groups.unshift({
            id: ALL_GROUPS,
            name: ALL_GROUPS,
            students: allStudents
        });
    }

    return {
        id: data.id,
        groups
    };
}

export default {
    getStudentsByGroup,
    resetStudentsByGroup
};



// WEBPACK FOOTER //
// ./components/report-filters/redux/students-by-group/students-by-group-actions.js